import { useProductEditor } from '../product-editor-context'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { slugify } from '@/lib/utils'

export function BasicsSection() {
  const { form, mode, product, skuUserEdited } = useProductEditor()

  // Auto-generate slug and SKU from title
  const handleTitleChange = (value: string) => {
    form.setValue('title', value)
    if (mode === 'create' || !product?.slug) {
      const slug = slugify(value)
      form.setValue('slug', slug)
    }
    if (!skuUserEdited) {
      const sku = slugify(value)
      if (sku) form.setValue('sku', sku)
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Basic Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormField
          control={form.control}
          name="title"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Title *</FormLabel>
              <FormControl>
                <Input
                  placeholder="Product title"
                  {...field}
                  onChange={(e) => handleTitleChange(e.target.value)}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="slug"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Slug *</FormLabel>
              <FormControl>
                <Input placeholder="product-slug" {...field} />
              </FormControl>
              <FormDescription>
                URL-friendly identifier (auto-generated from title)
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="short_description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Short Description</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Brief description for cards and previews"
                  className="h-20 resize-none"
                  {...field}
                />
              </FormControl>
              <FormDescription>
                Shown on product cards (max 500 characters)
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Full Description</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Full product description (HTML supported)"
                  className="h-40 resize-y"
                  {...field}
                />
              </FormControl>
              <FormDescription>
                Detailed description for the product page
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  )
}
